export default __webpack_public_path__ + "static/media/ssms.7bdcbaab.png";